module.exports = __webpack_public_path__ + "img/stripe.0a4961d6.svg";